import { render, staticRenderFns } from "./ScreenTransvaginalUteroComTridimensional.vue?vue&type=template&id=2ff28fb2&scoped=true&"
import script from "./ScreenTransvaginalUteroComTridimensional.vue?vue&type=script&lang=js&"
export * from "./ScreenTransvaginalUteroComTridimensional.vue?vue&type=script&lang=js&"
import style0 from "./ScreenTransvaginalUteroComTridimensional.vue?vue&type=style&index=0&id=2ff28fb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff28fb2",
  null
  
)

export default component.exports